module.exports = __webpack_public_path__ + "static-appopensalud/img/patterns-bg-2.d137e24.jpg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/bgs/patterns-bg-2.jpg
// module id = 2919
// module chunks = 10